import { useEffect } from "react";

export const useToggleBodyOverflow = (hidden: boolean) => {
  useEffect(() => {
    const body = document.body;
    const header = document.getElementsByTagName("header")[0];

    const isScrolling = body.clientHeight < body.scrollHeight;

    const scrollbarWidth = window.innerWidth - document.body.clientWidth;

    if (!isScrolling) {
      return;
    }
    if (hidden) {
      body.style.overflow = "hidden";
      if (scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
        header.style.paddingRight = `calc(1rem + ${scrollbarWidth}px)`;
      }
    } else {
      body.style.removeProperty("overflow");
      body.style.removeProperty("padding-right");
      header?.style?.removeProperty("padding-right");
    }
  }, [hidden]);
};
